import { Button, Carousel } from 'antd'
import React, { useRef, useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { BASE_URL } from '../../constants/Url'
import httpClient from '../../utils/HttpClient';
import { useTranslation } from 'react-i18next';
import NewsIcon from '../../assets/icons/News';
import EducationIcon from '../../assets/icons/Education';
import TrendsIcon from '../../assets/icons/Trends';
import ProductIcon from '../../assets/icons/Product';
import DownloadApp from '../../components/DownloadApp';
import AuthModal from '../../components/auth/AuthModal';
import { FaApple, FaAndroid } from 'react-icons/fa';
import { RiQrCodeLine } from 'react-icons/ri';
import { IoLogoAndroid } from "react-icons/io";
import { APP_ANDROID_APK_URL, APP_IOS_URL } from '../../config/api'
import AppQRDownloadModal from '../../components/AppQRDownloadModal'
import AppStoreDownloadModal from '../../components/AppStoreDownloadModal'
import AndroidDownloadModal from '../../components/AndroidDownloadModal'
import { MOBILE, IPAD, PC } from '../../constants/ConstantsKey';
import i18n from '../../i18n/config'

import { setAdsAction } from '../../modules/dataWebsite/actions';

export default function GuestHomePage() {
  const { t } = useTranslation();
  const currentLang = i18n.language;
  const navigate = useNavigate();
  const authModalRef = useRef();

  const user = useSelector((state) => state.authReducer);
  let token = user && user?.token ? user?.token : null;
  const responsive = useSelector((state) => state.responsive);
  const screen = responsive?.screen;
  const ads = useSelector((state) => state.dataWebsiteReducer?.adsData) || [];

  // State to track which panel is hovered. Default to the 3rd panel (index 2) like in the mockup
  const [activePanel, setActivePanel] = useState(null);

  useEffect(() => {
    httpClient.get('/ads').then(res => {
      if (res?.data?.data) {
        const adData = res.data.data;
        setAdsAction(Array.isArray(adData) ? adData : [adData]);
      }
    }).catch(err => console.error("fetch ads error", err));
  }, []);

  // Determines which panels are visible based on screen size
  const isPanelVisible = (index) => {
    return true; // All 5 panels visible on all screens
  };

  const handleCategoryClick = (tag) => {
    navigate(`/news?tag=${t(tag)}`);
  }

  const appQRDownloadModalRef = useRef(null);
  const appStoreDownloadModalRef = useRef(null);
  const androidDownloadModalRef = useRef(null);

  const openQrDownload = () => {
    appQRDownloadModalRef?.current?.showModal();
  }

  function downloadApk() {
    androidDownloadModalRef?.current?.showModal();
  }

  function downloadIos() {
    appStoreDownloadModalRef?.current?.showModal();
  }

  const bannerList = ads
    ?.filter((ad) => ad?.statusBanners !== false)
    ?.flatMap((ad) => ad?.banners || [])
    ?.filter((banner) => banner?.url) || [];

  const handleBannerClick = (banner) => {
    if (!banner?.linkUrl || !banner.linkUrl.trim()) return;

    const rawUrl = banner.linkUrl.trim();

    if (rawUrl.startsWith('http://') || rawUrl.startsWith('https://')) {
      try {
        const parsed = new URL(rawUrl);
        const internalPrefixes = [
          '/news',
          '/product',
          '/product-knowledge',
          '/technical',
          '/online-class',
          '/online-class-member',
          '/fashion',
          '/gallery',
          '/magazine',
          '/events',
          '/shareform'
        ];
        if (internalPrefixes.some((p) => parsed.pathname === p || parsed.pathname.startsWith(p + '/'))) {
          navigate(`${parsed.pathname}${parsed.search}${parsed.hash}`);
          return;
        }
      } catch (e) {
        // Fall through
      }
      if (banner.linkType === 'external' || !banner.linkType) {
        window.open(rawUrl, '_blank', 'noopener,noreferrer');
        return;
      }
    }

    // 3. Explicit external type
    if (banner.linkType === 'external') {
      const targetUrl =
        rawUrl.startsWith('http://') || rawUrl.startsWith('https://')
          ? rawUrl
          : `https://${rawUrl}`;
      window.open(targetUrl, '_blank', 'noopener,noreferrer');
      return;
    }

    // 4. Root-relative paths
    if (rawUrl.startsWith('/')) {
      navigate(rawUrl);
      return;
    }

    // 5. Bare internal routes
    if ([
      'shareform',
      'events',
      'news',
      'product-knowledge',
      'technical',
      'product',
      'online-class',
      'online-class-member',
      'fashion',
      'gallery',
      'magazine'
    ].some(p => rawUrl.startsWith(p))) {
      navigate(`/${rawUrl}`);
      return;
    }

    // 6. Default to product
    navigate(`/product/${rawUrl}`);
  };

  const panels = [
    {
      id: '01',
      subtitle: t('menu_text_01'),
      title: currentLang === "en" ? "Product" : t('category_product'),
      description: t('menu_text_product'),
      bgImage: BASE_URL + "/home/products.png",
      link: '/product'
    },
    {
      id: '02',
      subtitle: t('menu_text_02'),
      title: t('menu_tech_edu'),
      description: t('menu_text_tech'),
      bgImage: BASE_URL + "/home/techEducation.png",
      link: '/education'
    },
    {
      id: '03',
      subtitle: t('menu_text_03'),
      title: t('menu_fashion'),
      description: t('menu_text_fashion'),
      bgImage: BASE_URL + "/home/style.png",
      link: '/fashion'
    },
    {
      id: '04',
      subtitle: t('menu_text_04'),
      title: t('menu_news'),
      description: t('menu_text_news'),
      bgImage: BASE_URL + "/home/marketNews.png",
      link: '/news'
    },
    {
      id: '05',
      subtitle: t('menu_text_05'),
      title: t('menu_magazine'),
      description: t('menu_text_mazagine'),
      bgImage: BASE_URL + "/home/magazineSubscription.png",
      link: '/magazine'
    }
  ];

  return (
    <div className='w-full'>
      {/* Accordion Hero Section */}
      <div className="w-full h-[800px] md:h-[750px] lg:h-[600px] flex flex-col md:grid md:grid-cols-2 lg:flex lg:flex-row overflow-hidden relative">
        {panels.map((panel, index) => {
          const isActive = activePanel === index;
          const visible = isPanelVisible(index);
          return (
            <div
              key={panel.id}
              className={`relative h-full transition-all duration-500 ease-in-out cursor-pointer overflow-hidden border-b lg:border-b-0 md:border-r border-white/20 last:border-none flex-col justify-end ${
                visible ? 'flex' : 'hidden'
              } ${index === 4 ? 'md:col-span-2 lg:col-span-1' : ''}`}
              style={{
                flex: isActive
                  ? screen === MOBILE ? '1' : screen === IPAD ? '1' : '1'
                  : '1',
              }}
              onMouseEnter={() => setActivePanel(index)}
              onMouseLeave={() => setActivePanel(null)}
              onClick={() => {
                if (!isActive) {
                  setActivePanel(index);
                } else if (token) {
                  navigate(panel.link);
                }
              }}
            >
              {/* Background Image */}
              <img
                src={panel.bgImage}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700"
                alt=""
              />

              {/* Dark Overlay for inactive panels */}
              <div
                className={`absolute inset-0 bg-black transition-opacity duration-500 ${isActive ? 'opacity-0' : 'opacity-0'}`}
              ></div>

              {/* Hover Vibrant Gradient Overlay */}
              <div
                className={`absolute inset-0 bg-gradient-to-r from-blue-600/60 via-purple-500/50 to-pink-500/60 transition-opacity duration-500 ${isActive ? 'opacity-100' : 'opacity-0'}`}
              ></div>

              {/* Gradient Overlay for text readability at bottom */}
              <div className="absolute inset-0 bg-gradient-to-t from-[#111111]/90 via-[#111111]/30 to-transparent"></div>

              {/* Panel Content Wrapper */}
              <div className="absolute inset-0 text-white pointer-events-none">

                {/* Title & Description Container */}
                <div
                  className={`absolute left-4 sm:left-8 right-4 transition-all duration-500 ease-in-out flex flex-col ${isActive ? 'bottom-14 md:bottom-1/2 md:translate-y-[40%]' : 'bottom-5 sm:bottom-12 translate-y-0'}`}
                >
                  {/* Title */}
                  <div className={`flex flex-col transition-opacity duration-500 ${isActive ? 'opacity-100' : 'opacity-80'}`}>
                    <span className="text-[10px] md:text-xs font-light tracking-widest opacity-90">{panel.id} / {panel.subtitle}</span>
                    <span className="text-xl md:text-2xl font-medium mt-1 tracking-widest drop-shadow-md">{panel.title}</span>
                  </div>

                  {/* Description */}
                  <div
                    className={`overflow-hidden transition-all duration-500 ease-in-out`}
                    style={{
                      maxHeight: isActive ? '200px' : '0px',
                      opacity: isActive ? 1 : 0,
                      marginTop: isActive ? (screen === MOBILE ? '8px' : '20px') : '0px'
                    }}
                  >
                    <p className="text-xs md:text-sm font-light leading-loose max-w-[220px] md:max-w-[280px] whitespace-normal opacity-90">
                      {panel.description}
                    </p>
                  </div>
                </div>

                {/* Button Container */}
                <div
                  className={`absolute left-4 md:left-8 transition-all duration-500 ease-in-out ${isActive ? 'bottom-3 md:bottom-12 opacity-100 translate-y-0' : 'bottom-3 md:bottom-12 opacity-0 translate-y-4'}`}
                  style={{ pointerEvents: isActive ? 'auto' : 'none' }}
                >
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      if (token) {
                        navigate(panel.link);
                      } else {
                        authModalRef.current?.open();
                      }
                    }}
                    className="w-[130px] md:w-[237px] py-2 border border-white hover:text-white transition-colors text-white text-xs md:text-sm tracking-[0.2em] bg-transparent flex justify-center items-center backdrop-blur-sm"
                  >
                    {token ? t('button_explore_now') : t('button_login_unlock')}
                  </button>
                </div>
              </div>
            </div>
          );
        })}

        {/* Removed Navigation Dots */}
      </div>

      <div className='esi-white-space'></div>

      <div className='esi-std-container'>

        {/* about us */}
        <div className='md:grid grid-cols-5 gap-3 flex flex-col-reverse'>
          <div className='px-[20px] sm:px-0 max-w-[640px] pt-5 pb-5 sm:pb-10 col-span-3 flex flex-col gap-3'>
            <div className='esi-content-title'>
              {t("menu_about_us")}
              {/* <div className='esi-secondary-line'></div> */}
            </div>

            <div className='flex flex-col gap-4 mt-3'>
              <div className='esi-content-paragraph-gray'>{t(`text_about_us_1`)}</div>
              <div className='esi-content-paragraph-gray'>{t(`text_about_us_2`)}</div>
              <div className='esi-content-paragraph-gray'>{t(`text_about_us_3`)}</div>
            </div>
          </div>
          <div className='col-span-2 flex justify-center items-center sm:p-6 p-4'>
            <div className='relative w-full flex justify-center'>
              {/* Glowing blur effect behind the image */}
              {/* <div className="absolute inset-0 bg-gradient-to-br from-[#50c7f8] via-[#7887fd] to-[#df97fb] opacity-70 rounded-2xl"></div> */}

              {/* Solid gradient border */}
              <div className="relative p-3 sm:p-4 w-full flex justify-center items-center">
                <img src={BASE_URL + "/home/guestMagazine.png"} style={{ maxHeight: "462px" }} className='esi-image bg-white object-contain w-full' alt='ESI About Us' />
              </div>
            </div>
          </div>
        </div>

        <div className='esi-white-space'></div>
        {/* Download App Section */}
      </div>
      <div className='mb-5' style={{ background: "#fbf9f9" }}>
        <div className='esi-std-container'>
          <div className='grid grid-cols-1 lg:grid-cols-[1fr_auto] gap-8 items-center'>
            <div className='flex flex-col items-start gap-6 sm:gap-8 px-[20px] sm:px-[0px] pt-8 sm:pt-0'>
              <div className='text-3xl sm:text-4xl font-bold tracking-wider text-gray-900'>{t("text_download_app")}</div>

              <div className='flex flex-col items-start'>
                <div className=''>
                  <div className='w-full h-full flex justify-center items-center'>
                    <img src={BASE_URL + "/home/logoApp.png"} alt="ESIPRO Logo" className="w-full object-contain" />
                  </div>
                </div>
                <div className='text-gray-500 text-base sm:text-lg tracking-widest'>{t("text_logoText")}</div>
              </div>

              <div className='flex flex-wrap items-center gap-2.5 sm:gap-3 mt-4 w-full'>
                {/* App Store - gradient border */}
                <div className='h-11 sm:h-12 w-full sm:w-auto flex items-center p-[2px] bg-gradient-to-r from-[#50c7f8] via-[#7887fd] to-[#df97fb] shadow-md box-border'>
                  <button
                    onClick={downloadIos}
                    className={`justify-center flex items-center gap-2 px-4 sm:px-5 lg:px-6 text-white bg-gradient-to-r from-[#21163e] to-[#252554] hover:opacity-90 transition-all h-full w-full whitespace-nowrap ${currentLang === 'en' ? 'tracking-normal' : 'tracking-widest'}`}
                  >
                    <FaApple className='text-xl sm:text-2xl mb-0.5 shrink-0' />
                    <span className='text-xs sm:text-sm'>{t("text_appstore_down")}</span>
                  </button>
                </div>

                {/* Android - gradient border */}
                <div className='h-11 sm:h-12 w-full sm:w-auto flex items-center p-[2px] bg-gradient-to-r from-[#50c7f8] via-[#7887fd] to-[#df97fb] shadow-md box-border'>
                  <button
                    onClick={downloadApk}
                    className={`justify-center flex items-center gap-2 px-4 sm:px-5 lg:px-6 text-white bg-gradient-to-r from-[#21163e] to-[#252554] hover:opacity-90 transition-all h-full w-full whitespace-nowrap ${currentLang === 'en' ? 'tracking-normal' : 'tracking-widest'}`}
                  >
                    <IoLogoAndroid className='text-xl sm:text-2xl shrink-0' />
                    <span className='text-xs sm:text-sm'>{t("text_android_down")}</span>
                  </button>
                </div>

                {/* QR Code - plain border */}
                <button
                  onClick={openQrDownload}
                  className={`h-11 sm:h-12 w-full sm:w-auto justify-center flex items-center gap-2 px-4 sm:px-5 lg:px-6 text-gray-800 bg-white border border-gray-300 shadow-sm hover:bg-gray-50 transition-all whitespace-nowrap box-border ${currentLang === 'en' ? 'tracking-normal' : 'tracking-widest'}`}
                >
                  <RiQrCodeLine className='text-lg sm:text-xl shrink-0' />
                  <span className='text-xs sm:text-sm'>{t("text_wechat_official_account")}</span>
                </button>
              </div>
            </div>

            <div className='flex justify-center lg:justify-end px-4 sm:px-0 lg:-mr-6 shrink-0'>
              <img src={BASE_URL + "/home/magazineApp.png"} alt='Magazine App' className='w-full object-contain max-w-[360px] md:max-w-[400px] xl:max-w-[430px]' />
            </div>
          </div>
        </div>
      </div>
      {/* Selection Banner */}
      {bannerList.length > 0 && (
        <div className="w-full mt-10">
          <div className="esi-std-container">
            <Carousel
              className="esi-carousel-banner"
              draggable
              dots={bannerList.length > 1}
              pauseOnDotsHover
              pauseOnHover
              autoplay
            >
              {bannerList.map((banner, index) => {
                const hasLink = Boolean(banner?.linkUrl && banner.linkUrl.trim());
                return (
                  <div
                    key={banner._id || banner.url || index}
                    className={hasLink ? 'cursor-pointer' : 'cursor-default'}
                    onClick={() => {
                      if (hasLink) {
                        handleBannerClick(banner);
                      }
                    }}
                  >
                    <img
                      src={banner.url}
                      alt={banner.name || 'Banner Ad'}
                      className="w-full object-cover"
                      style={{ maxHeight: '300px' }}
                    />
                  </div>
                );
              })}
            </Carousel>
          </div>
        </div>
      )}
      {/* End Selection Banner */}
      <AuthModal ref={authModalRef} />
      <AppQRDownloadModal ref={appQRDownloadModalRef} />
      <AppStoreDownloadModal ref={appStoreDownloadModalRef} />
      <AndroidDownloadModal ref={androidDownloadModalRef} />
    </div>
  )
}
